/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Outlook_Ingest_Approval_ApproveInputs */

const es_components_outlook_ingest_approval_approve = /** @type {(inputs: Components_Outlook_Ingest_Approval_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobar`)
};

const en_components_outlook_ingest_approval_approve = /** @type {(inputs: Components_Outlook_Ingest_Approval_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve`)
};

/**
* | output |
* | --- |
* | "Approve" |
*
* @param {Components_Outlook_Ingest_Approval_ApproveInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_outlook_ingest_approval_approve = /** @type {((inputs?: Components_Outlook_Ingest_Approval_ApproveInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Outlook_Ingest_Approval_ApproveInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_outlook_ingest_approval_approve(inputs)
	return en_components_outlook_ingest_approval_approve(inputs)
});
export { components_outlook_ingest_approval_approve as "components.outlook_ingest_approval.approve" }